import { render, staticRenderFns } from "./default.vue?vue&type=template&id=0343b393"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScPhoneLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/PhoneLink.vue').default,ScEmailLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/EmailLink.vue').default,TopBar: require('/opt/build/repo/components/layout/TopBar.vue').default,PromoBanner: require('/opt/build/repo/components/offers/PromoBanner.vue').default,FooterSubscribe: require('/opt/build/repo/components/layout/FooterSubscribe.vue').default,FooterColumns: require('/opt/build/repo/components/layout/FooterColumns.vue').default,Espa: require('/opt/build/repo/components/layout/Espa.vue').default,Copyright: require('/opt/build/repo/components/layout/Copyright.vue').default,ExpoPopup: require('/opt/build/repo/components/ExpoPopup.vue').default,NotificationPopup: require('/opt/build/repo/components/NotificationPopup.vue').default,ScCookieBar: require('/opt/build/repo/node_modules/@evince/site/lib/packages/CookieBar.vue').default})
